import { Link } from 'react-router-dom';
import { SignInBrandLogo, useBranding } from '@l2u/web-shared';
import { supportEmailOf } from '@l2u/shared/brandingDefaults';
import { companyPath } from '../lib/audienceRoutes.ts';

export function CompanyExpired() {
  const { branding } = useBranding();
  const supportEmail = supportEmailOf(branding);
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <SignInBrandLogo align="center" className="mb-3" />
        <p className="mt-2 text-sm text-slate-600">
          Your sign-in link has expired. Links are single-use, so you’ll need a fresh one.
        </p>
        {/* Was a dead end: "contact your administrator to receive a new
            invitation" made every re-entry a support request, which is how
            renewal compliance quietly fails. */}
        <div className="mt-5">
          <Link
            to={companyPath('/login')}
            className="inline-flex items-center rounded-lg px-4 py-2 text-sm font-semibold text-white"
            style={{ background: 'var(--brand-primary)' }}
          >
            Email me a new sign-in link
          </Link>
        </div>
        <p className="mt-5 text-sm text-slate-500">
          Need help? Email{' '}
          <a href={`mailto:${supportEmail}`} className="text-blue-600 hover:underline">
            {supportEmail}
          </a>
          .
        </p>
      </div>
    </div>
  );
}
